import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { QidModelFailureModeCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    QidModelFailureModeValidation,
    SaveQidModelFailureMode,
    setQidModelEditFailureMode,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
    FormGroup,
    Input,
    Feedback,
    SpinnerIcon,
} from "client/components"

const EditFailureMode = () => {
    const failureMode = useSelector((state: StoreType) => state.qidModel.editFailureMode)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useState(failureMode ? failureMode.name : "")
    const [validation, setValidation] = useState<QidModelFailureModeValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        setName(failureMode ? failureMode.name : "")
        setValidation(null)
    }, [failureMode])

    const onCancel = () => {
        dispatch(setQidModelEditFailureMode(null))
    }

    const onSave = () => {
        setSaveState(PENDING)

        const newFailureModeData: QidModelFailureModeCreate = {
            safetyFunctionId: failureMode.safetyFunctionId,
            name,
        }

        SaveQidModelFailureMode(failureMode && failureMode.id, newFailureModeData, lang)
        .then((res) => {
            setValidation(res.validation)
            setSaveState(IDLE)
            if (res.validation) return

            dispatch(setQidModelReloadList(false))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidModelReloadList(true))
                dispatch(setQidDatapointReloadList(true))
            }, 0)

            dispatch(setQidModelEditFailureMode(null))
        })
    }

    return (
        <ConfirmWrapper show={failureMode !== null} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>
                    {failureMode && failureMode.id ? `${lang.editFailureMode} # ${failureMode.id}` : lang.addFailureMode}
                </ConfirmTitle>
                <FormGroup>
                    <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    <Feedback>{validation && validation.name}</Feedback>
                </FormGroup>

                <ConfirmBottom>
                    <Button variant="success" row onClick={onSave}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default EditFailureMode
